import { apiRequest, helpdeskModuleCreate, helpdeskServiceList } from "../../../../services/adapters/base";

class CreateRepository {
  fetchCreate = async (query) => {
    return await apiRequest(
      "post",
      helpdeskModuleCreate,
      {
        body: query,
      },
      true
    );
  };

  fetchServices = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      helpdeskServiceList,
      {
        cancelToken: cancelToken,
        params: query,
      },
      true
    );
  };
}

export default CreateRepository;
